import i18nConfig from '@/i18nConfig';
import { Resource, createInstance, i18n } from 'i18next';
import resourcesToBackend from 'i18next-resources-to-backend';
import { initReactI18next } from 'react-i18next/initReactI18next';

export default async function initTranslations(
  locale: string,
  namespaces?: string[],
  i18nInstance?: i18n,
  resources?: Resource
) {

  namespaces = namespaces || ["common"];
  i18nInstance = i18nInstance || createInstance();
  i18nInstance.use(initReactI18next);

  if (!resources) {
    i18nInstance.use(
      // httpBackend
      resourcesToBackend(
        (language: string, namespace: string) =>
          import(`@/public/locales/${language}/${namespace}.json`)
      )
    );
  }

  await i18nInstance.init({
    load: "currentOnly",
    lng: locale,
    resources,
    fallbackLng: i18nConfig.defaultLocale,
    supportedLngs: i18nConfig.locales,
    defaultNS: "common",
    fallbackNS: "common",
    ns: namespaces,
    // debug: process.env.DEBUG === "true",
    saveMissing: true,
    missingKeyHandler(_, ns, key, fallbackValue) {
      if (process.env.NODE_ENV !== "production") {
        if (typeof window !== 'undefined') {
          const rawMissing = window.localStorage.getItem('__mising_locale')
          const locales = rawMissing ? JSON.parse(rawMissing) : {}
          if (!locales[ns]) {
            locales[ns] = {}
          }
          locales[ns][key] = fallbackValue
          window.localStorage.setItem('__mising_locale', JSON.stringify(locales))
        }
        console.log("locale missing", {
          ns, key, obj: {
            [key]: fallbackValue
          }
        })
      }
    },
  });

  return {
    i18n: i18nInstance,
    t: i18nInstance.t,
    tp: {
      namespaces,
      locale,
      resources: i18nInstance.services.resourceStore.data,
    }
  };
}
